module.exports = __webpack_public_path__ + "static/overview-2de0d3cba737c2721745e0416c845c04.svg";